"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedDateTime = FormattedDateTime;
exports.FormattedNumber = FormattedNumber;
exports.FormattedRelativeTime = FormattedRelativeTime;
exports.L10nProvider = exports.L10NContext = void 0;
Object.defineProperty(exports, "Polyfills", {
  enumerable: true,
  get: function get() {
    return _smIntlProvider.Polyfills;
  }
});
Object.defineProperty(exports, "SmIntlProvider", {
  enumerable: true,
  get: function get() {
    return _smIntlProvider.default;
  }
});
exports.T = void 0;
exports.clearOptionsObject = clearOptionsObject;
exports.defineMessages = defineMessages;
exports.getMessageStore = getMessageStore;
exports.initIntl = initIntl;
exports.pricingFormattedNumber = void 0;
exports.resetMessageStore = resetMessageStore;
exports.substitute = substitute;
exports.t = t;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intlMessageformat = _interopRequireDefault(require("intl-messageformat"));
var _escapeHtml = _interopRequireDefault(require("escape-html"));
var _invariant = _interopRequireDefault(require("invariant"));
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _environment = require("@sm/utils/dist/environment");
var _languages = require("@sm/locale/dist/languages");
var _locale = require("@sm/locale");
var _relativeTimeFormat = _interopRequireDefault(require("./relativeTimeFormat"));
var _formats = _interopRequireWildcard(require("./formats"));
var _smIntlProvider = _interopRequireWildcard(require("./smIntlProvider"));
var _excluded = ["value"],
  _excluded2 = ["value"],
  _excluded3 = ["value", "countryCode"];
var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/intl/src/index.tsx",
  _process$versions;
/**
 * @module @sm/intl
 */
// fix for downstream tree-shaking
// fix for downstream tree-shaking
// fix for downstream tree-shaking
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var _getClientEnvironment = (0, _environment.getClientEnvironmentDetails)(),
  isBrowser = _getClientEnvironment.isBrowser;
var INTL_OPT_KEY = 'SM_intlUniqueOptionsObjectKey';
var INTL_MSG_STORE_KEY = 'SM_intlUniqueMessageStoreObjectKey';

/** Intl Options */

/** `{[local]: {[msgKey]: msgValue}}` */

/** Internal Variables on the Global/Window scope */

// ambient-type global variables on `Window` and `Global`

// See https://github.com/microsoft/TypeScript/issues/30139
// eslint-disable-next-line @typescript-eslint/no-namespace

var isNodeServer = typeof process !== 'undefined' && ((_process$versions = process.versions) === null || _process$versions === void 0 ? void 0 : _process$versions.node);
var isProd = isNodeServer && process.env.NODE_ENV === 'production';

// We don't want to log warnings on the server in production
var warningHandlerFn = isProd ? function () {
  /* no-op */
} : console.warn.bind(console); // eslint-disable-line

function getDefaultOptions() {
  return {
    currentLocale: null,
    // Current locale such as 'en-US' - `null` is not allowed for IntlMessageFormat and needs to be set
    warningHandler: warningHandlerFn,
    escapeHtml: true // disable escape html in variable mode
  };
}
function getStore() {
  var glob = isBrowser ? window : global;
  if (!glob[INTL_MSG_STORE_KEY]) {
    glob[INTL_MSG_STORE_KEY] = {};
  }
  return glob[INTL_MSG_STORE_KEY];
}
function getOptionsObject() {
  var glob = isBrowser ? window : global;
  if (!glob[INTL_OPT_KEY]) {
    glob[INTL_OPT_KEY] = getDefaultOptions();
  }
  return glob[INTL_OPT_KEY];
}
function clearOptionsObject() {
  if (isBrowser) {
    delete window[INTL_OPT_KEY];
  } else {
    delete global[INTL_OPT_KEY];
  }
}
var intlRelativeFormat;

/**
 * @param {string} input
 * @returns {string} hash
 * @private
 */
function hashInput(input) {
  var hash = 0;
  var i;
  var chr;
  if (input.length === 0) return hash;
  for (i = 0; i < input.length; i += 1) {
    chr = input.charCodeAt(i);
    hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise
    // Convert to 32bit integer
    hash |= 0; // eslint-disable-line no-bitwise
  }
  return hash;
}
var randomStr = function randomStr(N) {
  return _toConsumableArray(Array(N)).map(function () {
    return (~~(Math.random() * 36)).toString(36);
  }).join('');
}; // eslint-disable-line no-bitwise

var keysOf = Object.keys;
var maybePseudo = function maybePseudo(msg) {
  if (process.env.NODE_ENV !== "production" && isBrowser) {
    var pseudoFactor = window.location.href.toString().match(/[&?]intl-pseudo(=([0-9]*\.[0-9]+|[0-9]+))?/);
    if (pseudoFactor) {
      return msg.replace(/\S+/g, function (match) {
        return randomStr(parseInt("".concat(match.length * parseFloat("".concat(pseudoFactor[2] || 1))), 10) || 1);
      });
    }
  }
  return msg;
};
var replacer = function replacer(elements) {
  return function (part) {
    var element = elements[part];
    return element || maybePseudo(part);
  };
};

/** `string` type-guard including check for `instanceof` */
// work-around as  TS does not infer type string for instanceof
var isString = function isString(s) {
  return typeof s === 'string' || s instanceof String;
};

/**
 *
 * @param {string} message
 * @param {Object} variables (Optional)
 * @returns {Object} The substitution
 */
function substitute(message, variables) {
  // Some test cases are passing an object as a message. This is a workaround to avoid breaking the tests.
  if (typeof message !== 'string') {
    return message;
  }
  var vars = _objectSpread({}, variables);
  var msg = message;
  var options = getOptionsObject();
  var uid = Math.abs(hashInput(JSON.stringify({
    msg: msg,
    keys: keysOf(vars)
  }))).toString(16);
  var tokenDelimiter = "@__".concat(uid, "__@");
  var tokenizedValues = {};
  var elements = {};
  var generateToken = function () {
    var counter = 0;
    return function () {
      counter += 1;
      return "ELEMENT-".concat(uid, "-").concat(counter);
    };
  }();
  keysOf(vars).forEach(function (name) {
    var value = vars[name];
    if (/*#__PURE__*/_react.default.isValidElement(value)) {
      var token = generateToken();
      tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
      elements[token] = value;
    } else if (options.escapeHtml === true && isString(value) && value.indexOf('<') >= 0 && value.indexOf('>') >= 0) {
      tokenizedValues[name] = (0, _escapeHtml.default)(value);
    } else {
      // `React.isValidElement` matches `React.ReactElement` so its type can be omitted
      tokenizedValues[name] = value;
    }
  });
  try {
    // messageFormat.format() throws an error if the message contains tags unlike the older version
    if (isString(msg)) {
      msg = msg.replace(/</g, '@@@LT@@@').replace(/>/g, '@@@GT@@@');
    }
    var msgFormatter = options.currentLocale && options.formats ? new _intlMessageformat.default(msg, options.currentLocale, options.formats) : new _intlMessageformat.default(msg);
    msg = msgFormatter.format(tokenizedValues);
    if (isString(msg)) {
      msg = msg.replace(/@@@LT@@@/g, '<').replace(/@@@GT@@@/g, '>');
    } else if ('join' in msg) {
      msg = msg.join('');
    }
  } catch (err) {
    // replacing the escaped characters back to their original form
    if (isString(msg)) {
      msg = msg.replace(/@@@LT@@@/g, '<').replace(/@@@GT@@@/g, '>');
    } else if ('join' in msg) {
      msg = msg.join('');
    }
    options.warningHandler({
      context: 'sm/intl',
      error: 'message_formatting_error',
      err: err,
      msg: msg,
      tokenizedValues: tokenizedValues,
      vars: vars,
      currentLocale: options.currentLocale
    });
    return msg;
  }
  try {
    var stack = [];
    var exhausted = false;
    var runningIndex = 0;
    while (!exhausted) {
      var _slice$match, _slice;
      // The runningIndex is the pointer in the string at which we want to look right (->).
      var match = (_slice$match = (_slice = msg.slice(runningIndex)).match) === null || _slice$match === void 0 ? void 0 : _slice$match.call(_slice, /<span id="([^<>]+)">|<\/span>/);
      if (match) {
        // eslint-disable-next-line prefer-const
        var _ref = match,
          _ref2 = _slicedToArray(_ref, 2),
          matched = _ref2[0],
          tag = _ref2[1];

        // we need to adjust for the running index because match.index is relative to the substring we used
        var matchIndex = (match.index || 0) + runningIndex;
        var isOpening = !!tag;
        if (isOpening) {
          // If it's an opening tag, just push it on the stack and move on.
          stack.push({
            tag: tag,
            index: matchIndex
          });
          runningIndex = matchIndex + matched.length;
        } else {
          // We reached an ending </span> tag.

          var popped = stack.pop();
          if (!popped) {
            options.warningHandler({
              context: 'sm/intl',
              error: 'unbalanced_delimiters_extra_closing',
              message: message,
              tokenizedValues: tokenizedValues,
              vars: vars
            });
            return message;
          }
          runningIndex = popped.index;
          // Find the content between the opening tag and the current one
          var content = msg.substring(runningIndex, matchIndex).replace(/<span id="([^<>]+)">/, '').replace(/<\span>/, '');
          var children = void 0;
          // If there are other functional elements saved already, try to split
          // the content and replace them with the right elements.
          if (elements && keysOf(elements).length > 0) {
            children = content.split(tokenDelimiter).filter(function (part) {
              return !!part;
            }).map(replacer(elements));
          } else {
            children = content;
          }

          // Build an element by cloning the passed element or calling the
          // passed function.
          var element = vars[popped.tag]({
            children: children
          });
          if (/*#__PURE__*/_react.default.isValidElement(element)) {
            element = /*#__PURE__*/_react.default.cloneElement(element, {
              key: "".concat(popped.tag, "_").concat(randomStr(8))
            });
          }

          // Build the new string and adjust the running index based on that token.
          var token = generateToken();
          var tokenReplacement = "".concat(tokenDelimiter).concat(token).concat(tokenDelimiter);
          msg = "".concat(msg.substring(0, popped.index)).concat(tokenReplacement).concat(msg.substring(matchIndex + matched.length, msg.length));
          elements[token] = element;
        }
      } else {
        exhausted = true;
      }
    }
    if (stack.length) {
      options.warningHandler({
        context: 'sm/intl',
        error: 'unbalanced_delimiters_extra_opening',
        message: message,
        tokenizedValues: tokenizedValues,
        vars: vars
      });
      return message;
    }
    // Do a final replace once we're done with matching
    if (elements && keysOf(elements).length > 0) {
      msg = msg.split(tokenDelimiter).filter(function (part) {
        return !!part;
      }).map(replacer(elements));
    } else {
      msg = maybePseudo(msg);
    }
    return msg;
  } catch (err) {
    options.warningHandler({
      context: 'sm/intl',
      error: 'unexpected_tokenization_error',
      message: message,
      err: err
    });
    return message;
  }
}

/**
 * Retrieves and format a particular message by key. Uses defaultMessage if key is not found in message list.
 * @param {string} key Unique identifier for this string
 * @param {Object} variables (Optional) - Key/values for string substitution
 * @param {string} defaultMessage (Optional) Default message if string isn't found for key
 * @private
 */
function get(key, variables, defaultMessage) {
  var vars = variables;
  var _getOptionsObject = getOptionsObject(),
    currentLocale = _getOptionsObject.currentLocale,
    warningHandler = _getOptionsObject.warningHandler;
  var messages = getStore()[currentLocale];
  if (!key) {
    warningHandler({
      context: 'sm/intl',
      error: 'key_is_undefined',
      currentLocale: currentLocale,
      key: key,
      defaultMessage: defaultMessage
    });
    return '';
  }
  var msg;
  if (!messages) {
    // If currentLocale is not set, return the default message without warning.
    if (currentLocale) {
      warningHandler({
        context: 'sm/intl',
        error: 'locale_not_found_in_message_store',
        currentLocale: currentLocale
      });
    }
    msg = defaultMessage || '';
  }
  msg = msg || messages[key];
  if (!msg && defaultMessage) {
    if (currentLocale !== 'en-US') {
      warningHandler({
        context: 'sm/intl',
        error: 'message_not_found_default_fallback',
        currentLocale: currentLocale,
        key: key
      });
    }
    msg = defaultMessage;
  }
  if (!msg) {
    warningHandler({
      context: 'sm/intl',
      error: 'message_not_found_no_default',
      currentLocale: currentLocale,
      key: key,
      defaultMessage: defaultMessage
    });
    return '';
  }
  return substitute(msg, vars);
}

/**
 * @param {string} key
 * @param {Object} variables
 * @param {string} defaultMessage
 * @returns {string} html
 * @private
 */
function getHTML(key, variables, defaultMessage) {
  var msg = get(key, variables, defaultMessage);
  if (msg) {
    var el = /*#__PURE__*/_react.default.createElement('span', {
      dangerouslySetInnerHTML: {
        __html: msg
      }
    });
    // when key exists, it should still return element if there's defaultMessage() after getHTML()
    var defaultMsg = function defaultMsg() {
      return el;
    };
    return _objectSpread({
      defaultMessage: defaultMsg,
      d: defaultMsg
    }, el);
  }
  return '';
}

// =================== Public API

/**
 * Definition function used by our babel-plugin to extract messages during development.
 * For the description, Type must have one of the following values `Button | Link | Label | Header | Paragraph`. Vis, for visibility, must be one of `low | med | high`.
 *
 * More in the {@link https://webplatform.pages.mntv-infra.com/#/pages/webs/localization?id=definemessages|WebPlatform docs}
 *
 * @param {Object} v Key/Descriptor objects where Descriptor.id, Descriptor.defaultMessage and Descriptor.description are present.
 * @returns {Object} message definition
 *
 */
function defineMessages(v) {
  return v;
}

/**
 * Translates a message matching a specific Descriptor object.
 * Ref: https://webplatform.pages.mntv-infra.com/#/pages/webs/localization
 *
 * @param {Desc} desc Descriptor object for the current message to translate. ({id: String!, defaultMessage: String!, description: String})
 * @param {Object} values (Optional) - key/values for substitution based on the ICU message format.
 * @param {Object} opts (Optional)
 * @param {Object} opts.html (Optional/Defaults to `false`) - Whether or not to allow for HTML nodes in the message before substitution.
 * @returns {string|React.ReactElement} HTML string or key value
 */
function t(desc, values) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var id = desc.id,
    defaultMessage = desc.defaultMessage;
  var html = opts.html;
  return (html ? getHTML : get)(id, values, defaultMessage); // force return type
}

/** Props for `T` React component */

/**
 * (React Component) Translates a message matching a specific Descriptor object.
 * Ref: https://webplatform.pages.mntv-infra.com/#/pages/webs/localization?id=definemessages
 */
var T = exports.T = function T(props) {
  var desc = props.desc,
    values = props.values,
    id = props.id,
    defaultMessage = props.defaultMessage,
    html = props.html;
  return (html ? getHTML : get)(desc ? desc.id : id, values, desc ? desc.defaultMessage : defaultMessage);
};
T.propTypes = {
  desc: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    defaultMessage: _propTypes.default.string.isRequired,
    description: _propTypes.default.string
  }),
  id: _propTypes.default.string,
  // PropTypes.node does not include `true`
  // (see https://github.com/facebook/prop-types/issues/199)
  // elementType is needed for react-based-tokenization - so we can pass in the element to substitute
  values: _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool, _propTypes.default.elementType])),
  defaultMessage: _propTypes.default.string,
  html: _propTypes.default.bool
};
T.defaultProps = {
  desc: undefined,
  id: undefined,
  values: undefined,
  defaultMessage: undefined,
  html: false
};

/**
 * Initialize the localization framework with the passed messages and set of currentLocale/currentLanguage. Can be called more than once.
 * @param {Object} messages Key/Values where keys are string IDs and values are the translated message for such ID.
 * @param {Options} [opts={}] Options for Intl
 * @returns {void}
 */
function initIntl(/** Key/Values where keys are string IDs and values are the translated message for such ID */
messages) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  !opts.currentLocale ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'opts.currentLocale is required') : (0, _invariant.default)(false) : void 0;
  !opts.currentLanguage ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'opts.currentLanguage is required') : (0, _invariant.default)(false) : void 0;
  !messages ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'messages is required') : (0, _invariant.default)(false) : void 0;
  var options = getOptionsObject();
  options.currentLocale = opts.currentLocale;
  options.currentLanguage = opts.currentLanguage;
  options.warningHandler = opts.warningHandler || options.warningHandler;
  var messageStore = getStore();
  var langInited = !!messageStore[options.currentLocale];
  (0, _lodash.default)(messageStore, _defineProperty({}, options.currentLocale, messages));
  options.formats = _objectSpread(_objectSpread(_objectSpread({}, options.formats), opts.formats), _formats.default);
  if (langInited) {
    return;
  }
  intlRelativeFormat = new _relativeTimeFormat.default(options.currentLocale, _objectSpread({}, _formats.default.relativeTime || {}));
}

/**
 * Clears the object where we store messages. Useful for testing
 * @returns {undefined}
 */
function resetMessageStore() {
  var messageStore = getStore();
  Object.keys(messageStore).forEach(function (member) {
    return delete messageStore[member];
  });
}

/**
 * Retrieves a copy of the stored messages.
 * @returns {JSON} JSON Message Store
 */
function getMessageStore() {
  return JSON.parse(JSON.stringify(getStore()));
}
/**
 * The FormattedDateTime component uses the Intl.DateTimeFormat API and as such, here are the supported props.
 * All optionals.
 *
 * type DateTimeFormatOptions = {
 *   localeMatcher: 'best fit' | 'lookup' = 'best fit',
 *   formatMatcher: 'basic' | 'best fit' = 'best fit',
 *
 *   timeZone: string,
 *   hour12  : boolean,
 *
 *   weekday     : 'narrow' | 'short' | 'long',
 *   era         : 'narrow' | 'short' | 'long',
 *   year        : 'numeric' | '2-digit',
 *   month       : 'numeric' | '2-digit' | 'narrow' | 'short' | 'long',
 *   day         : 'numeric' | '2-digit',
 *   hour        : 'numeric' | '2-digit',
 *   minute      : 'numeric' | '2-digit',
 *   second      : 'numeric' | '2-digit',
 *   timeZoneName: 'short' | 'long',
 * };
 *
 * @param {Date} props Actual date to format.
 * @returns {string} formatted date
 */
function FormattedDateTime(props) {
  var _options$currentLocal;
  var value = props.value,
    restProps = _objectWithoutProperties(props, _excluded);
  var options = getOptionsObject();
  return new Intl.DateTimeFormat((_options$currentLocal = options.currentLocale) !== null && _options$currentLocal !== void 0 ? _options$currentLocal : undefined, _objectSpread(_objectSpread({}, _formats.default.dateTime || {}), restProps)).format(value);
}

// Until we update to the latest typescript, we need will need to defined our own options
// See https://github.com/microsoft/TypeScript/issues/43336
var digitOptionValues = Array.from(Array(21).keys(), function (item) {
  return item + 1;
});
digitOptionValues.push(undefined);
/**
 * The FormattedNumber component uses the Intl.NumberFormat API and as such, here are the supported props.
 * All optionals.
 *
 * type NumberFormatOptions = {
 *   localeMatcher: 'best fit' | 'lookup' = 'best fit',
 *
 *   style: 'decimal' | 'currency' | 'percent' = 'decimal',
 *
 *   currency       : string,
 *   currencyDisplay: 'symbol' | 'code' | 'name' = 'symbol',
 *
 *   useGrouping: boolean = true,
 *
 *   minimumIntegerDigits    : number = 1,
 *   minimumFractionDigits   : number,
 *   maximumFractionDigits   : number,
 *   minimumSignificantDigits: number = 1,
 *   maximumSignificantDigits: number,
 * };
 *
 * @param {number} props Actual number to format.
 * @returns {string} Formatted number
 */
function FormattedNumber(props) {
  var _options$currentLocal2;
  var value = props.value,
    restProps = _objectWithoutProperties(props, _excluded2);
  var options = getOptionsObject();
  restProps.style = restProps.formatStyle;
  return new Intl.NumberFormat((_options$currentLocal2 = options.currentLocale) !== null && _options$currentLocal2 !== void 0 ? _options$currentLocal2 : undefined, _objectSpread(_objectSpread({}, _formats.default.number || {}), restProps)).format(value);
}

/**
 * This routine returns products representation of formatted number for pricing related work.
 * It uses the Intl.NumberFormat API and as such under the hood.
 * This is expanded to support the currency for a specific country code and the Intl.NumberFormatOptions.
 * @param countryCode
 * @param props
 * @returns
 */
var pricingFormattedNumber = exports.pricingFormattedNumber = function pricingFormattedNumber(props) {
  var value = props.value,
    countryCode = props.countryCode,
    restProps = _objectWithoutProperties(props, _excluded3);
  var country = (0, _locale.sanitizeCountryCode)(countryCode);
  var options = getOptionsObject();
  var number = _formats.default.number;
  var supportedCurrency = restProps.currency ? number[restProps.currency] : {};
  !supportedCurrency ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'currency code is not in the supported list of countries') : (0, _invariant.default)(false) : void 0;
  var locale = (0, _formats.targetCountryLocaleCodes)(country, options.currentLocale);
  var formattedCurrency = new Intl.NumberFormat(locale !== null && locale !== void 0 ? locale : undefined, _objectSpread(_objectSpread({}, supportedCurrency), restProps)).format(value);
  return formattedCurrency;
};
/**
 * The FormattedRelativeTime component uses the IntlRelativeTime API and as such, here are the supported props.
 * All optionals.
 *
 * type RelativeTimeFormatOptions = {
 *   units: 'second' | 'second-short' | 'minute' | 'minute-short' | 'hour' | 'hour-short' | 'day' | 'day-short' | 'month' | 'month-short' | 'year' | 'year-short'
 *   style: 'best fit' | 'numeric'
 * };
 *
 * @param {Object} props
 * @param {Date} props.value Actual date to format.
 * @param {Date} props.now (Optional) Fix the value of "now" to a certain date.
 * @returns {string} Formatted date
 */
function FormattedRelativeTime(props) {
  var value = props.value,
    now = props.now;
  return intlRelativeFormat.format(value, {
    now: now
  });
}

/** Context is currently only used to prevent isRTL prop drilling */
var L10NContext = exports.L10NContext = /*#__PURE__*/(0, _react.createContext)({
  isRTL: false
});
var RTLLanguageCodes = _languages.LANGUAGES.filter(function (l) {
  return l.isRTL;
}).map(function (l) {
  return l.code;
});
/**
 * Configures the global localization context for the whole page.
 * @class
 */
var L10nProvider = exports.L10nProvider = /*#__PURE__*/function (_React$Component) {
  function L10nProvider(props) {
    var _this;
    _classCallCheck(this, L10nProvider);
    _this = _callSuper(this, L10nProvider, [props]);
    _this.state = {
      messages: null,
      isRTL: false
    };
    var currentLocale = props.localeCode;
    var currentLanguage = props.languageCode;

    // If the locale is english, we are not expecting any messages; hence, default to {}
    _this.state.messages = _this.getMessages();
    /**
     * `SSR/isNode` - Initialize Intl on the server with the provided messages (if any).
     * `messages ` - We already have the messages (SSR/CSR/en-US), initIntl right away.
     *
     * The above takes care of three scenarios -
     * 1. SSR - Everything is provided on the server; hence, no need to fetch messages.
     * 2. CSR + messages - Messages were fetched before this component; hence, no need to fetch messages.
     * 3. In the case of `en-US`, we really don't need messages.
     */
    var _getClientEnvironment2 = (0, _environment.getClientEnvironmentDetails)(),
      isNode = _getClientEnvironment2.isNode;
    if (isNode || _this.state.messages) {
      initIntl(_this.state.messages, {
        currentLocale: currentLocale,
        currentLanguage: currentLanguage
      });
    }
    if (RTLLanguageCodes.indexOf(currentLanguage) !== -1) {
      _this.state.isRTL = true;
    }
    return _this;
  }
  _inherits(L10nProvider, _React$Component);
  return _createClass(L10nProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Update text-direction
      if (prevProps.languageCode !== this.props.languageCode) {
        var isRTL = RTLLanguageCodes.indexOf(this.props.languageCode) !== -1;
        if (isRTL !== this.state.isRTL) {
          this.setState(function () {
            return {
              isRTL: isRTL
            };
          });
        }
      }

      // Update messages at runtime is not yet implemented
    }

    /** Picks the correct localized messages */
  }, {
    key: "getMessages",
    value: function getMessages() {
      return this.props.localeCode === 'en-US' ? {} : this.props.localeMessages || {};
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.messages) {
        return null;
      }
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        _react.default.createElement(L10NContext.Provider, {
          value: {
            isRTL: this.state.isRTL
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 993,
            columnNumber: 7
          }
        }, this.props.children)
      );
    }
  }]);
}(_react.default.Component);
L10nProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  localeMessages: _propTypes.default.object,
  // eslint-disable-line
  localeCode: _propTypes.default.string,
  languageCode: _propTypes.default.string
};
L10nProvider.defaultProps = {
  localeCode: 'en-US',
  languageCode: 'en'
};
//# sourceMappingURL=index.js.map